import { useMutation, useQueryClient } from '@tanstack/react-query';
import httpClient from '../services/http-client';
import { ExternalOrderService, ExternalOrderSubmissionResponse } from '../services/external-order-service';

const externalOrderService = new ExternalOrderService(httpClient);

interface CreateExternalOrderVariables {
  orderData: any;
  divisionId?: string;
}

export const useCreateExternalOrder = () => {
  const queryClient = useQueryClient();

  return useMutation<ExternalOrderSubmissionResponse, Error, CreateExternalOrderVariables>({
    mutationFn: ({ orderData, divisionId }) => externalOrderService.submitJsonOrder(orderData, divisionId),
    onSuccess: () => {
      // Invalidate and refetch any relevant queries
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      queryClient.invalidateQueries({ queryKey: ['external-orders'] });
    },
  });
};